<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='grid-wrap'>
      <dx-data-grid
        :data-source='inventoryAdjustHistory'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        :key-expr="['등록일']"
        @toolbar-preparing='onToolbarPreparing'
        @cell-prepared='onCellPrepared'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="exportTitle"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumn
          :allowEditing='true'
          sort-order='asc'
          caption="품번"
          data-field="품번"
        >
        </DxColumn>
        <DxColumn
          caption="등록일"
          data-field="등록일"
          sort-order='desc'
          dataType='date'
          format='yyyy-MM-dd'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품명"
          data-field="품명"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
        >
          <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          caption="창고재고"
          alignment='center'
        >
          <DxColumn
            :allowEditing='true'
            caption="보정전재고"
            data-field="보정전재고"
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="보정재고수량"
            data-field="보정재고"
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
        </DxColumn>
        <DxColumn
          caption="재공재고"
          alignment='center'
        >
          <DxColumn
            :allowEditing='true'
            caption="보정전재공"
            data-field="보정전재공"
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="보정재공수량"
            data-field="보정재공"
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="등록자성명"
          data-field="성명"
        >
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="등록일"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../../share/ConstDef'
import AppLib from '../../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxTotalItem, DxLookup,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport } from 'devextreme-vue/data-grid'

export default {
  name: 'StockAdjustHistory',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      exportTitle: null,
      itemTypeLookup: null,
      inventoryAdjustHistory: null,
      thisYear: null,
      yearArray: []
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxTotalItem,
    DxLookup,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport
  },
  computed: {

  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.thisYear = AppLib.getThisYear()
    for (let i = this.thisYear; i >= 2021; i--) {
      this.yearArray.push({ 'year': i })
    }
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.refreshHistory()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onCellPrepared (e) {
      if (e.rowType === 'data') {
        if (e.column.dataField === '보정재고') {
          if (e.data.보정재고 < 0) {
            this.$Q(e.cellElement).css('color', 'red')
          } else if (e.data.보정재고 > 0) {
            this.$Q(e.cellElement).css('color', 'blue')
          }
        }
        if (e.column.dataField === '보정재공') {
          if (e.data.보정재공 < 0) {
            this.$Q(e.cellElement).css('color', 'red')
          } else if (e.data.보정재공 > 0) {
            this.$Q(e.cellElement).css('color', 'blue')
          }
        }
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: (args) => {
              this.thisYear = args.value
              this.refreshHistory()
            }
          }
        }
      )
    },
    refreshHistory () {
      this.isLoading = true
      this.exportTitle = `${this.thisYear}년도_재고조정현황`
      this.$_sp.runNoEncodeFindProc('spFinaAllStockAdjustHistoryByYear', { 등록년도: this.thisYear })
        .then((data) => {
          this.isLoading = false
          this.inventoryAdjustHistory = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
